import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import {
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  IonBackButton,
  IonButtons,
} from '@ionic/react';
import {
  Box,
  Typography,
  Container,
  Divider,
  Paper,
} from '@mui/material';

const Terms: React.FC = () => {
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton defaultHref="/auth" />
          </IonButtons>
          <IonTitle>{t('terms.title')}</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <Container maxWidth="md" sx={{ py: 3 }}>
          <Paper elevation={2} sx={{ p: 4 }}>
            <Typography 
              variant="h4" 
              component="h1" 
              gutterBottom 
              sx={{ 
                textAlign: 'center',
                mb: 4,
                color: 'primary.main',
                fontWeight: 'bold'
              }}
            >
              {t('terms.title')}
            </Typography>

            <Typography variant="body2" color="text.secondary" sx={{ mb: 4, textAlign: 'center' }}>
              {t('terms.lastUpdated')}: {new Date().toLocaleDateString()}
            </Typography>

            {/* Section 1: Conditions Générales d'Utilisation */}
            <Box sx={{ mb: 4 }}>
              <Typography variant="h5" component="h2" gutterBottom sx={{ color: 'primary.main', fontWeight: 'bold' }}>
                {t('terms.cgu.title')}
              </Typography>
              
              <Typography variant="h6" component="h3" gutterBottom sx={{ mt: 3, fontWeight: 'bold' }}>
                {t('terms.cgu.article1.title')}
              </Typography>
              <Typography variant="body1" paragraph>
                {t('terms.cgu.article1.content')}
              </Typography>

              <Typography variant="h6" component="h3" gutterBottom sx={{ mt: 3, fontWeight: 'bold' }}>
                {t('terms.cgu.article2.title')}
              </Typography>
              <Typography variant="body1" paragraph>
                {t('terms.cgu.article2.content')}
              </Typography>

              <Typography variant="h6" component="h3" gutterBottom sx={{ mt: 3, fontWeight: 'bold' }}>
                {t('terms.cgu.article3.title')}
              </Typography>
              <Typography variant="body1" paragraph>
                {t('terms.cgu.article3.content')}
              </Typography>

              <Typography variant="h6" component="h3" gutterBottom sx={{ mt: 3, fontWeight: 'bold' }}>
                {t('terms.cgu.article4.title')}
              </Typography>
              <Typography variant="body1" paragraph>
                {t('terms.cgu.article4.content')}
              </Typography>

              <Typography variant="h6" component="h3" gutterBottom sx={{ mt: 3, fontWeight: 'bold' }}>
                {t('terms.cgu.article5.title')}
              </Typography>
              <Typography variant="body1" paragraph>
                {t('terms.cgu.article5.content')}
              </Typography>
            </Box>

            <Divider sx={{ my: 4 }} />

            {/* Section 2: Politique de Confidentialité */}
            <Box sx={{ mb: 4 }}>
              <Typography variant="h5" component="h2" gutterBottom sx={{ color: 'primary.main', fontWeight: 'bold' }}>
                {t('terms.privacy.title')}
              </Typography>

              <Typography variant="h6" component="h3" gutterBottom sx={{ mt: 3, fontWeight: 'bold' }}>
                {t('terms.privacy.collection.title')}
              </Typography>
              <Typography variant="body1" paragraph>
                {t('terms.privacy.collection.content')}
              </Typography>

              <Typography variant="h6" component="h3" gutterBottom sx={{ mt: 3, fontWeight: 'bold' }}>
                {t('terms.privacy.usage.title')}
              </Typography>
              <Typography variant="body1" paragraph>
                {t('terms.privacy.usage.content')}
              </Typography>

              <Typography variant="h6" component="h3" gutterBottom sx={{ mt: 3, fontWeight: 'bold' }}>
                {t('terms.privacy.sharing.title')}
              </Typography>
              <Typography variant="body1" paragraph>
                {t('terms.privacy.sharing.content')}
              </Typography>

              <Typography variant="h6" component="h3" gutterBottom sx={{ mt: 3, fontWeight: 'bold' }}>
                {t('terms.privacy.security.title')}
              </Typography>
              <Typography variant="body1" paragraph>
                {t('terms.privacy.security.content')}
              </Typography>

              <Typography variant="h6" component="h3" gutterBottom sx={{ mt: 3, fontWeight: 'bold' }}>
                {t('terms.privacy.rights.title')}
              </Typography>
              <Typography variant="body1" paragraph>
                {t('terms.privacy.rights.content')}
              </Typography>

              <Typography variant="h6" component="h3" gutterBottom sx={{ mt: 3, fontWeight: 'bold' }}>
                {t('terms.privacy.cookies.title')}
              </Typography>
              <Typography variant="body1" paragraph>
                {t('terms.privacy.cookies.content')}
              </Typography>
            </Box>

            <Divider sx={{ my: 4 }} />

            {/* Section 3: Contact */}
            <Box sx={{ mb: 4 }}>
              <Typography variant="h5" component="h2" gutterBottom sx={{ color: 'primary.main', fontWeight: 'bold' }}>
                {t('terms.contact.title')}
              </Typography>
              <Typography variant="body1" paragraph>
                {t('terms.contact.content')}
              </Typography>
              <Typography variant="body1" paragraph>
                <strong>Email:</strong> wiselinker614@gmail.com
              </Typography>
            </Box>
          </Paper>
        </Container>
      </IonContent>
    </IonPage>
  );
};

export default Terms;